export default function LongArrowRight() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="65.668" height="9.966" viewBox="0 0 65.668 9.966">
            <g id="Group_3" data-name="Group 3" transform="translate(0 0.354)">
                <line id="Line_1" data-name="Line 1" x2="65" transform="translate(0 4.63)" fill="none" stroke="#fff" stroke-width="1"/>
                <line id="Line_2" data-name="Line 2" x1="4.63" y1="4.63" transform="translate(60.685)" fill="none" stroke="#fff" stroke-width="1"/>
                <line id="Line_3" data-name="Line 3" x1="4.63" y2="4.63" transform="translate(60.685 4.63)" fill="none" stroke="#fff" stroke-width="1"/>
            </g>
        </svg>
    )
}